import React, { useState, useEffect } from "react";
import "./ShopDetails.css";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, initialFetchProducts } from '../../../Features/filter/fetch_products';
import Filter from "../Filters/Filter";
import { Link } from "react-router-dom";
import FavoriteButton from "../../Favourite_button/favourite_button";
import { FaStar, FaStarHalfAlt, FaRegStar  } from "react-icons/fa";
import { IoFilterSharp, IoClose } from "react-icons/io5";
import CircleLoading from "../../CirculusIndicator/CircleLoading";
const ShopDetails = () => {
  const dispatch = useDispatch();
  const { products, lastVisible, status } = useSelector((state) => state.products);


  useEffect(() => {
    if (products.length === 0 && status === "idle") {
      console.log('calling this ')
      dispatch(initialFetchProducts());
    }
  }, [dispatch, status, products.length]);


  const fetchMoreData = () => {
    if (status === "succeeded" && lastVisible) {
      dispatch(fetchProducts());
    }
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  
  return (
    <>
      <div className="shopDetails">
        <div className="shopDetailMain">
          <div className="shopDetails__left">
            <Filter />
          </div>
          <div className="shopDetails__right">
            <div className="shopDetailsSorting">
              <div className="shopDetailsBreadcrumbLink">
                <Link to="/" onClick={scrollToTop}>
                  Home
                </Link>
                &nbsp;/&nbsp;
                <Link to="/shop">The Shop</Link>
              </div>
              <div className="filterLeft" onClick={toggleDrawer}>
                <IoFilterSharp />
                <p>Filter</p>
              </div>
            </div>
            {status === "loading" ? 
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            ><CircleLoading /></div> 
            : ""}
            <InfiniteScroll
              dataLength={products.length} // Current number of products in the list
              next={fetchMoreData} // Function to fetch more products
              hasMore={status === "succeeded" && lastVisible !== null} // Check if more products are available
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: "center", marginTop: "20px" }}>
                  {status === "no-more-products" ? "You've reached the end of the list." : ""}
                </p>}
            >
              <div className="shopDetailsProducts">
                <div className="shopDetailsProductsContainer">
                  {products.map((product) => (
                    <div className="sdProductContainer">
                      <div className="sdProductImages">
                        
                        <Link  to={`/product/${product.productId}`}
                          state={{ product }}  onClick={scrollToTop}>
                          <img
                            src={product.images[0]}
                            alt=""
                            className="sdProduct_front"
                          />
                          <img
                            src={product.images[1]}
                            alt=""
                            className="sdProduct_back"
                          />
                        </Link>
                        {/* <h4 onClick={() => handleAddToCart(product)}>
                          Add to Cart
                        </h4> */}
                      </div>
                      {/* <div
                        className="sdProductImagesCart"
                        onClick={() => handleAddToCart(product)}
                      >
                        <FaCartPlus />
                      </div> */}
                      <div className="sdProductInfo">
                        <div className="sdProductCategoryWishlist">
                         <p>{product.category}</p>
                          <FavoriteButton productId={product.productId} />
                          {/* <FiHeart
                            onClick={() => handleWishlistClick(product.id)}
                            style={{
                              color: wishList[product.id]
                                ? "red"
                                : "#767676",
                              cursor: "pointer",
                            }}
                          /> */}
                        </div>
                        <div className="sdProductNameInfo">
                          <Link to={`/product/${product.productId}`}
                            state={{ product }}  onClick={scrollToTop}>
                            <h5>{product.title}</h5>
                          </Link>
                          <p>
                            {product.hasDiscount ? (
                              <>
                                <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                                  Rs.{product.price}
                                </span>
                                <span style={{ color: "black",  }}>Rs.{product.discountPrice}</span>
                              </>
                            ) : (
                              <span>Rs.{product.price}</span>
                            )}
                          </p>
                          {/* <p>${product.price}</p> */}
                          <div className="sdProductRatingReviews">
                            <div className="sdProductRatingStar">
                              {Array.from({ length: 5 }).map((_, index) => {
                                const rating = product.totalRating / product.totalPeopleReview; // Calculate average rating
                                const fullStars = Math.floor(rating);
                                const hasHalfStar = rating - fullStars >= 0.5;
                                if (index < fullStars) {
                                  return <FaStar key={index} color="#FEC78A" size={14} />;
                                } else if (index === fullStars && hasHalfStar) {
                                  return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                                } else {
                                  return <FaRegStar key={index} color="#FEC78A" size={14} />;
                                }
                              })}
                            </div>
                            <span>{product.totalPeopleReview}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <div className={`filterDrawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="drawerHeader">
          <p>Filter By</p>
          <IoClose onClick={closeDrawer} className="closeButton" size={26} />
        </div>
        <div className="drawerContent">
          <Filter />
        </div>
      </div>
    </>
  );
};

export default ShopDetails;
